import MiraklIcon from '../components/common/icons/compra_mercado.svg';
import RipleyIcon from '../components/common/icons/compra_ripley.svg';

import SuccessIcon from '../components/common/icons/ic_exito.svg';
import ErrorIcon from '../components/common/icons/ic_error.svg';
import AlertIcon from '../components/common/icons/ic_alerta.svg';

import SuccessMessageIcon from '../components/common/icons/ic_svg_exito.svg';
import ErrorMessageIcon from '../components/common/icons/ic_svg_error.svg';
import AlertMessageIcon from '../components/common/icons/ic_svg_alerta.svg';
import InfoMessageIcon from '../components/common/icons/ic_svg_notificacion.svg';
import InfoBlueMessageIcon from '../components/common/icons/ic_svg_info.svg';

export const iconChooser = (isMirakl) => {
  return isMirakl ? MiraklIcon : RipleyIcon;
};

export const iconSeverityPicker = (severity) => {
  switch (severity) {
    case 'success':
      return SuccessIcon;
    case 'error':
      return ErrorIcon;
    default:
      return AlertIcon;
  }
};

export const iconProductMessagePicker = (severity) => {
  switch (severity) {
    case 'success':
      return SuccessMessageIcon;
    case 'error':
      return ErrorMessageIcon;
    case 'alert':
      return AlertMessageIcon;
    case 'info':
      return InfoBlueMessageIcon;
    case 'info-blue-background':
      return InfoBlueMessageIcon;
    default:
      return InfoMessageIcon;
  }
};
